// Custom: Enhances Shopify-rendered contact form feedback for WCAG 2.2 status and error notification.
// Custom: Runs only after Shopify renders a success or error message; it does not intercept or alter form submission.
(() => {
  const FEEDBACK_MESSAGE_SELECTOR = '[data-custom-contact-form-status]';
  const ANNOUNCEMENT_DELAY = 150;
  const FIXED_HEADER_OFFSET = 70;
  const FOCUSED_MESSAGE_OFFSET = 12;
  const RESTORE_SCROLL_BEHAVIOR_DELAY = 500;
  const REMOVE_ANNOUNCEMENT_DELAY = 5000;

  const onPageLoad = (callback) => {
    if (document.readyState === 'complete') {
      callback();
      return;
    }

    window.addEventListener('load', callback, { once: true });
  };

  const getMessageText = (element) => element.textContent.replace(/\s+/g, ' ').trim();

  const announce = (message, isError) => {
    // Custom: Dynamic live-region update makes post-submit feedback available to screen readers after a full page reload.
    const liveRegion = document.createElement('div');
    liveRegion.className = 'visually-hidden';
    liveRegion.setAttribute('role', isError ? 'alert' : 'status');
    liveRegion.setAttribute('aria-live', isError ? 'assertive' : 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');

    document.body.append(liveRegion);

    window.requestAnimationFrame(() => {
      liveRegion.textContent = message;
    });

    window.setTimeout(() => {
      liveRegion.remove();
    }, REMOVE_ANNOUNCEMENT_DELAY);
  };

  const focusWithoutScroll = (element) => {
    try {
      element.focus({ preventScroll: true });
    } catch (_error) {
      element.focus();
    }
  };

  const scrollFeedbackBelowHeader = (messageElement) => {
    const messageTop = messageElement.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: Math.max(0, messageTop - FIXED_HEADER_OFFSET - FOCUSED_MESSAGE_OFFSET),
      behavior: 'auto',
    });
  };

  const focusPageFeedback = (messageElement) => {
    const root = document.documentElement;
    const previousScrollBehavior = root.style.scrollBehavior;
    const isError = messageElement.dataset.customContactFormStatus === 'error';

    // Custom: Shopify reloads to the contact form anchor; replace that with one instant, header-safe focus position.
    root.style.scrollBehavior = 'auto';

    window.requestAnimationFrame(() => {
      focusWithoutScroll(messageElement);
      scrollFeedbackBelowHeader(messageElement);

      window.setTimeout(() => {
        announce(getMessageText(messageElement), isError);
      }, ANNOUNCEMENT_DELAY);

      window.setTimeout(() => {
        root.style.scrollBehavior = previousScrollBehavior;
      }, RESTORE_SCROLL_BEHAVIOR_DELAY);
    });
  };

  onPageLoad(() => {
    const feedbackMessage = document.querySelector(FEEDBACK_MESSAGE_SELECTOR);

    if (!(feedbackMessage instanceof HTMLElement)) return;
    if (feedbackMessage.dataset.customContactFormAnnounced === 'true') return;

    const messageText = getMessageText(feedbackMessage);
    if (!messageText) return;

    feedbackMessage.dataset.customContactFormAnnounced = 'true';
    focusPageFeedback(feedbackMessage);
  });
})();